<span [inlineSVG]="'./assets/media/icons/duotune/arrows/arr066.svg'" class="svg-icon"></span>
